import script from "./PersonalitiesCardMini.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalitiesCardMini.vue?vue&type=script&setup=true&lang=js"

import "./PersonalitiesCardMini.vue?vue&type=style&index=0&id=88b5269a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88b5269a"]])

export default __exports__